import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { loadClientLpEpic } from './_epics/loadClientLp.epic';
import { loadClientLpAdapterSchemaEpic } from './_epics/loadClientLpAdapterSchema.epic';
import { loadClientLpListEpic } from './_epics/loadClientLpList.epic';
import { updateClientLpEpic } from './_epics/updateClientLp.epic';
import { startClientLpProcessingEpic } from './_epics/startClientLpProcessing.epic';
import { endClientLpProcessingEpic } from './_epics/endClientLpProcessing.epic';

export const clientLpEpic = safeCombineEpics(
  loadClientLpEpic,
  loadClientLpAdapterSchemaEpic,
  loadClientLpListEpic,
  updateClientLpEpic,
  startClientLpProcessingEpic,
  endClientLpProcessingEpic,
);
